<template>
  <div class="section" v-if="component != null">
    <div class="centered pt-4" v-if="component.title != null">
      <span class="minititle blue_8--text text-center">{{
        component.title
      }}</span>
    </div>
    <v-row dense v-if="component.subsection != null">
      <v-col v-for="(elem, id) in component.subsection" :key="id" cols="12">
        <SubSection :component="elem" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import SubSection from "./Subsection";
export default {
  name: "Section",
  components: { SubSection },
  props: {
    index: {
      type: Number,
      default: 0
    },
    component: {
      type: Object,
      default: null
    }
  }
};
</script>

<style scoped></style>
